import { ICellRendererParams } from "@ag-grid-community/core";
import { Content } from "@iventis/translations/content/typed-content";
import React, { FunctionComponent } from "react";
import { StyledTextCell } from "../styles/data-table.styles";

export const BooleanCell: FunctionComponent<ICellRendererParams> = ({ value, context }) => {
    // eslint-disable-next-line react/destructuring-assignment
    const translate = context.translate ? context.translate : (t) => t;

    let valueText: string;
    if (value === true) {
        valueText = translate(Content.common.yes);
    }
    if (value === false) {
        valueText = translate(Content.common.no);
    }

    if (value === undefined || value === null) {
        valueText = "";
    }

    return <StyledTextCell>{valueText}</StyledTextCell>;
};
